
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.432 13a.876.876 0 01-.316-.056.731.731 0 01-.273-.19L2.222 8.906c-.154-.164-.228-.377-.222-.638a.932.932 0 01.243-.637.774.774 0 01.59-.246c.238 0 .434.082.589.246l3.01 3.199 7.136-7.584a.787.787 0 01.6-.246c.246 0 .446.082.6.246.155.164.232.377.232.637 0 .262-.077.474-.232.638l-7.746 8.233a.731.731 0 01-.274.19.876.876 0 01-.316.056z","fill":"#515952"}})])
          )
        }
      }
    